import type { EmployerAgreementVersion } from '@festina/life-general-types/life'
import { EmployerAgreementsService_employerAgreementsVersionsServiceGetEntityByQuery } from '@festina/life-general-types/life/hooks/EmployerAgreementsVersionsService_employerAgreementsVersionsServiceGetEntityByQuery'

export const useFetchEmployerAgreementVersion =
  EmployerAgreementsService_employerAgreementsVersionsServiceGetEntityByQuery.useSuspenseQuery<EmployerAgreementVersion | null>
